import * as type from './type'
import { TYPE_PREFIX } from './type'

export const createInitialTableState = (tableName, queryName, orderBy = {}, initialConfig = {}) => {
    return {
        [tableName]: {
            queryName,
            currentPage: 0,
            objectPerPage: 20,
            filter: {},
            orderBy: orderBy,
            offset: 0,
            limit: 500,
            objectList: [],
            hiddenColumns: [],
            ...initialConfig,
        },
    }
}

export const ASC = 'ASC'
export const DESC = 'DESC'

export const toggleSort = (currentSortOrder) => {
    return !currentSortOrder || currentSortOrder === DESC ? ASC : DESC
}

export const toggleSortMulti = (currentSortOrder) => {
    if (!currentSortOrder) {
        return ASC
    }
    if (currentSortOrder === ASC) {
        return DESC
    }
    if (currentSortOrder === DESC) {
        return null
    }
}


export const createReducerFunction = (tableName) => ({
    [TYPE_PREFIX + tableName + type.QUERY_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [TYPE_PREFIX + tableName + type.QUERY_SUCCESS]: (state, action) => {
        const { objectList } = action.payload
        return {
            ...state,
            [tableName]: {
                ...state[tableName],
                objectList,
            },
            fetching: false,
        }
    },
    [TYPE_PREFIX + tableName + type.QUERY_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [TYPE_PREFIX + tableName + type.CHANGE_FILTER]: (state, action) => {
        const { columnName, filterValue } = action.payload
        return {
            ...state,
            [tableName]: {
                ...state[tableName],
                filter: {
                    ...state[tableName].filter,
                    [columnName]: filterValue,
                },
            },
            fetching: true,
        }
    },
    [TYPE_PREFIX + tableName + type.TOGGLE_SORT]: (state, action) => {
        const { columnName } = action.payload
        const currentOrder = state[tableName].orderBy[columnName]
        return {
            ...state,
            [tableName]: {
                ...state[tableName],
                orderBy: {
                    [columnName]: toggleSort(currentOrder),
                },
            },
            fetching: true,
        }
    },
    [TYPE_PREFIX + tableName + type.SET_HIDDEN_COLUMNS]: (state, action) => {
        const hiddenColumns = action.payload
        return {
            ...state,
            [tableName]: {
                ...state[tableName],
                hiddenColumns: hiddenColumns,
            }
        }
    },
    [TYPE_PREFIX + tableName + type.TOGGLE_MULTI_SORT]: (state, action) => {
        const { columnName } = action.payload
        const currentOrder = state[tableName].orderBy[columnName]
        return {
            ...state,
            [tableName]: {
                ...state[tableName],
                orderBy: {
                    ...state[tableName].orderBy,
                    [columnName]: toggleSortMulti(currentOrder),
                },
            },
            fetching: true,
        }
    },
    [TYPE_PREFIX + tableName + type.GOTO_PAGE]: (state, action) => {
        const { page } = action.payload
        return {
            ...state,
            [tableName]: {
                ...state[tableName],
                currentPage: page,
            },
        }
    },
})



// WEBPACK FOOTER //
// ./src/modules/table/state/reducer.js